import { render, staticRenderFns } from "./DecodedModelChoicePanel.vue?vue&type=template&id=a3dd394c&scoped=true"
import script from "./DecodedModelChoicePanel.vue?vue&type=script&lang=js"
export * from "./DecodedModelChoicePanel.vue?vue&type=script&lang=js"
import "./DecodedModelChoicePanel.vue?vue&type=style&index=0&id=a3dd394c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd394c",
  null
  
)

export default component.exports